<!-- <p>rules-page works!</p>
<span>
  residentRulesId {{ neighborhoodService.currentNeighborhood?.residentRulesId }}
  <br />
  guardRulesId {{ neighborhoodService.currentNeighborhood?.guardRulesId }}
</span> -->

@if(neighborhoodService.currentNeighborhood) {

  <div class="container-fluid pt-4">
    <div class="row">

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Reglamento del fraccionamiento
        </b></small>
      </div>
  
      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">

          @if(neighborhoodService.currentNeighborhood.residentRules) {
            <div class="col-12">
              <div class="bg-light rounded px-3 py-3">
                <div class="row">

                  <div class="col-auto d-flex align-items-center">
                    <i class="material-icons text-secondary">
                      @if(neighborhoodService.currentNeighborhood.residentRules.fileType == 'image') {
                        image
                      } @else {
                        picture_as_pdf
                      }
                    </i>
                  </div>

                  <div class="col d-flex align-items-center mb-3 mb-md-0">
                    Reglamento_del_fraccionamiento.{{ neighborhoodService.currentNeighborhood.residentRules.fileType == 'image' ? 'jpg' : 'pdf' }}
                  </div>

                  <div class="col-auto d-flex flex-row">

                    <a
                      class="btn btn-sm btn-primary rounded-circle d-flex align-items-center justify-content-center me-2"
                      [href]="neighborhoodService.currentNeighborhood.residentRules.urlFile"
                      target="_blank"
                      style="width: calc(1.8rem + 1.8vh); height: calc(1.8rem + 1.8vh);"
                      placement="top" 
                      ngbTooltip="Ver documento">
                      <i class="material-icons mt-1">more_vert</i>
                    </a>

                    <button
                      type="button"
                      (click)="showResidentRules = !showResidentRules"
                      class="btn btn-sm btn-dark rounded-circle d-flex align-items-center justify-content-center"
                      style="width: calc(1.8rem + 1.8vh); height: calc(1.8rem + 1.8vh);"
                      placement="top" 
                      ngbTooltip="Editar">
                      <i class="material-icons">edit</i>
                      
                    </button>

                  </div>

                </div>
              </div>
            </div>
          }

          @if(
            !neighborhoodService.currentNeighborhood.residentRulesId ||
            showResidentRules
          ) {

            <div 
              class="col-12 mb-3 col-md-6"
              [ngClass]="{
                'mt-3': showResidentRules
              }">
              <label for="file" class="form-label mb-2">Subir reglamento (PDF o imagen)</label>
              <input
                type="file"
                id="file"
                class="form-control"
                accept=".pdf, .jpg, .jpeg, .png"
                (change)="onResidentRulesFileChange($event)">
            </div>
  
            <div class="col-12 col-md-6 d-flex align-items-center">
              <button
                type="button"
                class="btn btn-success w-100 d-flex align-items-center justify-content-center"
                (click)="updateResidentRules()"
                [disabled]="!residentRulesUpdateButtonEnabled">
                <i class="material-icons me-2">save</i>
                Guardar
              </button>
            </div>

          }

        </div>
      </div>

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Reglamento de seguridad (Para vigilantes)
        </b></small>
      </div>
  
      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">

          @if(neighborhoodService.currentNeighborhood.guardRules) {
            <div class="col-12">
              <div class="bg-light rounded px-3 py-3">
                <div class="row">

                  <div class="col-auto d-flex align-items-center">
                    <i class="material-icons text-secondary">
                      @if(neighborhoodService.currentNeighborhood.guardRules.fileType == 'image') {
                        image
                      } @else {
                        picture_as_pdf
                      }
                    </i>
                  </div>

                  <div class="col d-flex align-items-center mb-3 mb-md-0">
                    Reglamento_de_vigilancia.{{ neighborhoodService.currentNeighborhood.guardRules.fileType == 'image' ? 'jpg' : 'pdf' }}
                  </div>

                  <div class="col-auto d-flex flex-row">

                    <a
                      class="btn btn-sm btn-primary rounded-circle d-flex align-items-center justify-content-center me-2"
                      [href]="neighborhoodService.currentNeighborhood.guardRules.urlFile"
                      target="_blank"
                      style="width: calc(1.8rem + 1.8vh); height: calc(1.8rem + 1.8vh);"
                      placement="top" 
                      ngbTooltip="Ver documento">
                      <i class="material-icons mt-1">more_vert</i>
                    </a>

                    <button
                      type="button"
                      (click)="showGuardRules = !showGuardRules"
                      class="btn btn-sm btn-dark rounded-circle d-flex align-items-center justify-content-center"
                      style="width: calc(1.8rem + 1.8vh); height: calc(1.8rem + 1.8vh);"
                      placement="top" 
                      ngbTooltip="Editar">
                      <i class="material-icons">edit</i>
                      
                    </button>

                  </div>

                </div>
              </div>
            </div>
          }

          @if(
            !neighborhoodService.currentNeighborhood.residentRulesId ||
            showGuardRules
          ) {

            <div 
              class="col-12 mb-3 col-md-6"
              [ngClass]="{
                'mt-3': showGuardRules
              }">
              <label for="file" class="form-label mb-2">Subir reglamento (PDF o imagen)</label>
              <input
                type="file"
                id="file"
                class="form-control"
                accept=".pdf, .jpg, .jpeg, .png"
                (change)="onGuardRulesFileChange($event)">
            </div>

            <div class="col-12 col-md-6 d-flex align-items-center">
              <button
                type="button"
                class="btn btn-success w-100 d-flex align-items-center justify-content-center"
                (click)="updateGuardRules()"
                [disabled]="!guardRulesUpdateButtonEnabled">
                <i class="material-icons me-2">save</i>
                Guardar
              </button>
            </div>

          }

        </div>
      </div>

    </div>
  </div>

} @else {

  <div class="d-flex justify-content-center">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

}